import React from 'react';
import driver from '../Asset/images/Picture.png';
import navi from '../Asset/images/P03.png';

const Future = () => {
    return (
        <div className='future' id="future">
            <div className='container'>
                <div className='row gx-0 futures'>
                    <div className='col-md-3 mt-16 future_chaild'>
                        <img src={driver} alt="driver" className='driver_img'></img>
                    </div>
                    <div className='col-md-9'>
                        <div className='row'>
                            <div className='col-md-5 future_chaild_1'>
                                <img src={navi} alt="driver" className='monider_img'></img>
                            </div>
                            <div className='col-md-7 future_content'>
                                <h1 className='text-7xl md:text-9xl font-thin'>The <br></br>
                                    Future
                                </h1>
                            </div>
                            <div className='offset-md-4  col-md-8 future_cont'>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Future